import type { Tone } from "@/model/view-types"

/**
 * Areas and agents no longer carry colour (refined-system: avatars on `fill`, Lea ink; decision 0056). The `Tone` type
 * and the stored colours stay; every tone renders the same quiet classes.
 */
const mono = {
  solid: "bg-ink text-paper",
  soft: "bg-fill text-ink",
  text: "text-ink",
  border: "border-rule",
  hex: "#17181B",
} as const

/** Static class names per tone (spelled out so Tailwind can see them). */
export const toneClasses: Record<
  Tone,
  { solid: string; soft: string; text: string; border: string; hex: string }
> = {
  teal: mono,
  green: mono,
  blue: mono,
  purple: mono,
  amber: mono,
  neutral: mono,
}

/** Translucent lane fill and border for graph swimlanes. */
export const laneColors = (_tone: Tone) => ({
  fill: "rgba(23,24,27,0.03)",
  border: "rgba(23,24,27,0.12)",
  text: mono.hex,
})

/**
 * UX pass 2026-10-15: an agent's stored avatar colour paints her avatar again (the picker in her Identity card showed
 * six black dots). Only agents' squares take it; people, areas and lanes stay quiet. `neutral` (the default, stored as
 * "slate") is the quiet look: fill for an agent, ink for the lead. Each colour carries white text at ≥ 4.5:1.
 */
export const agentAvatarColor: Record<Tone, string | null> = {
  teal: "#0e6b6b",
  green: "#2b6b3f",
  blue: "#2f4cb3",
  purple: "#6a3d9a",
  amber: "#94560c",
  neutral: null,
}
